<template>
  <div class="review-rating">
    <div class="review-rating__container">
      <!-- Rating Value -->
      <div class="rating-value">
        <span class="rating-number">{{ formattedRating }}</span>
      </div>

      <!-- Rating Section -->
      <div class="review-rating__rating">
        <nuxt-rating
          :rating-value="rating"
          :increment="0.01"
          :read-only="true"
          :show-rating="false"
          :rating-size="ratingSize"
          active-color="#FFD700"
          inactive-color="#E0E0E0" />
      </div>

      <!-- Google Image -->
      <div class="review-rating__google-image">
        <img
          :src="googleImageSrc"
          alt="Powered by Google"
          class="google-image" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import googleImage from '~/assets/images/powered-by-google.png'

  // Props
  const props = defineProps({
    rating: {
      type: Number,
      default: 0,
      validator: value => value >= 0 && value <= 5
    },
    ratingSize: {
      type: Number,
      default: 20
    },
    showValue: {
      type: Boolean,
      default: true
    }
  })

  // Computed properties
  const googleImageSrc = computed(() => googleImage)

  const formattedRating = computed(() => {
    return props.rating.toFixed(1)
  })
</script>

<style lang="scss" scoped>
.review-rating {
  background-color: var(--color-light-grey);
  padding: 12px;
  min-width: 650px;
  border-radius: 10px;

  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  &__rating {
    margin-top: -4px;
  }

  @include up-to-tablet {
    min-width: 100%;
  }
}

.google-image {
  height: 16px;
  width: auto;
  object-fit: contain;
}

.rating-value {
  .rating-number {
    font-size: 14px;
    color: #717171;
    line-height: 1;
  }
}

// Override nuxt-rating styles if needed
:deep(nuxt-rating) {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
